import React from 'react';
import styled from 'styled-components';

import { useCardContext } from './card-context';

/** Renders the "Sponsored" label when the product is ad-sponsored. */
export function CardSponsoredTag(): JSX.Element | null {
  const { isSponsored, hideSponsoredTag } = useCardContext();

  if (!isSponsored || hideSponsoredTag) {
    return null;
  }

  return <Sponsored>Sponsored</Sponsored>;
}

const Sponsored = styled.div`
  color: #828a8f;
  font-size: 10px;
  line-height: 1;
  margin-bottom: 6px;
`;
